
if (process.env.NODE_ENV === 'production') {
    window.location.href = '#';
}



function hashHandler() {
    activeTab(location.hash);
    history.pushState(null, null, window.location.href.split("#")[0]);
}

function activeTab(href) {

    document.querySelectorAll('a.active').forEach((e) => {
        e.classList.remove('active');
    });

    const link = document.querySelector(`[href="${href}"]`);

    if (link) {
        link.classList.add('active')
    }
}

hashHandler();

window.addEventListener('hashchange', hashHandler, false);

let lastScroll = window.scrollY;

window.addEventListener('scroll', (e) => {

    let focus;

    document.querySelectorAll('section').forEach((e) => {
        if (window.scrollY > (e.offsetTop - window.innerHeight / 2))
            focus = e;
    });

    if (focus) {
        activeTab(`#${focus.id}`);
    }

    if (window.scrollY > lastScroll)
        document.body.classList.add('sticky');
    else if (window.scrollY < lastScroll)
        document.body.classList.remove('sticky');

    lastScroll = window.scrollY;

}, false);

window.addEventListener('click', (e) => {
    if (!document.getElementById('menu').contains(e.target)) {
        document.body.classList.remove('show-menu');
    } else {
        document.body.classList.toggle('show-menu');
    }
});